'use client';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  type ChartData,
  type ChartOptions,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface LoginLineChartProps {
  data: ChartData<'line'>;
  options: ChartOptions<'line'>;
}

/** Isolated in its own module so the chart.js runtime can be code-split away
 *  from the user-stats route's initial JavaScript via `next/dynamic`. */
export default function LoginLineChart({ data, options }: LoginLineChartProps) {
  return <Line data={data} options={options} />;
}
